<template>
  <div class="app-page-container">
    <div class="app-body">
      <h3  class="text-danger"> {{$t("deletePend.title")}}</h3>
        <div class="step-bar-bg">
      <p class="desc"> {{$t("deletePend.desc")}} </p>
      </div>
      <div class="account-info">
        <div class="info-line">
          <span class="title">  {{$t("common.game")}}</span>
          <span class="info">{{ $store.state.gameName }}</span>
        </div>
        <div class="info-line">
          <span class="title">  {{$t("common.playerId")}}</span>
          <span class="info">{{ $store.state.aid }}</span>
        </div>
        <div class="info-line">
          <span class="title">  {{$t("common.pin")}}</span>
          <span class="info">{{ $store.state.pin }}</span>
        </div>
      </div>
      <p class="del-cancel-tip" >
        {{$t("deletePend.tip")}} 
      </p>
      <!-- <button class="game-button warning" v-if="flag" @click="cancelDel">
        Cancel Account Deletion
      </button> -->
      <!-- <button class="game-button primary" disabled v-if="!flag">
        账户删除中
      </button> -->
                     <div class="btn-for-vertical">

       <button class="game-button primary" @click="$router.push({ name: 'Home'})" >
         {{$t("nav.home")}}
      </button>
      </div>

    </div>
    <description></description>
    <footerBar @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
export default {
  data() {
    return {
      flag: 0,
    };
  },
  components: {
    footerBar,
    description,
  },
  mounted() {
    
  },
  methods: {
      showLanguage(){
      this.$emit('showLanguage')
    },
    cancelDel() {
      const _this = this;
      this.$axios({
        method: "post",
        url: "/privacy/cancel/del",
        data: {
          pinToken: _this.$cookie.get("token"),
          ua:navigator.userAgent || ''
        },
      })
        .then((res) => {
          if (res.status === 200) {
            Toast({
              message: "OK",
            });
            _this.$router.push("./Home");
          }
        })
        .catch(() => {
          Toast({
            message: "error",
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
// .title {
//   padding-top: 50px;
//   margin-bottom: 1.5rem;
//   font-weight: 700;
//   font-size: 1.75rem;
// }
.white {
  background: transparent;
}
.desc {
   font-size: 0.34rem;
   margin-bottom: .5rem;
}
.text-danger {
  padding-top: 1rem;
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
}
.del-cancel-tip {
  color: #dc3545;
  font-weight: 500;
  margin-bottom: .32rem;
    font-size: .38rem;
  text-align: center;
}
.account-info {
  padding-top: .5rem;
    padding-bottom:.5rem;
    border:1px solid #D5DBE5;
   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.14);
    border-radius: 0.32rem;
    margin-bottom: 0.42rem;
    display: flex;
    flex-direction: column;
  .info-line {
    margin: 0.18rem 0;
    display: flex;
    padding: 0 0.64rem;
    .title {
      flex: 1;
      font-weight: 700;
      font-size: .42rem;
      color: #818181;
    }
    .info {
      flex: 2;
      font-size:.42rem;
            color: #262626;
            font-weight: 700;

    }
  }
}
.step-bar-bg{
  background: #F1F1F1 ;
      border-radius: 0.32rem;
      padding: 0.42rem;
      margin-bottom: 0.42rem;
}
@media screen and (orientation: landscape) {
.btn-for-vertical{
  width: 60%;
  margin: 0 auto;
  padding-left: .6rem;
  padding-right:  .6rem;
  box-sizing: border-box;
  }
}
</style>